(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('Passenger', Passenger);

    Passenger.$inject = ['$resource', 'DateUtils'];

    function Passenger ($resource, DateUtils) {
        var resourceUrl =  'api/passengers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.birthDate = DateUtils.convertLocalDateFromServer(data.birthDate);
                        data.documentExpire = DateUtils.convertLocalDateFromServer(data.documentExpire);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.birthDate = DateUtils.convertLocalDateToServer(copy.birthDate);
                    copy.documentExpire = DateUtils.convertLocalDateToServer(copy.documentExpire);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.birthDate = DateUtils.convertLocalDateToServer(copy.birthDate);
                    copy.documentExpire = DateUtils.convertLocalDateToServer(copy.documentExpire);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();
